import React from 'react';
import { getComputedCSSVariable } from '../../utils/cssVariableHelpers';

interface Props {
  color?: string,
  style?: object,
}

const LocationMarkerSVG: React.FC<Props> = ({
  color,
}) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M8 3.2C5.86546 3.2 4.17647 4.88835 4.17647 6.92C4.17647 7.91488 4.63453 8.86325 5.42575 9.86925C6.09343 10.7182 6.94819 11.5484 7.86895 12.4428C7.91249 12.4851 7.95618 12.5275 8 12.5701C8.04382 12.5275 8.08751 12.4851 8.13105 12.4428C9.05181 11.5484 9.90657 10.7182 10.5743 9.86925C11.3655 8.86325 11.8235 7.91488 11.8235 6.92C11.8235 4.88835 10.1345 3.2 8 3.2ZM3 6.92C3 4.17991 5.26144 2 8 2C10.7386 2 13 4.17991 13 6.92C13 8.31099 12.3551 9.52263 11.4919 10.6202C10.7702 11.5378 9.84656 12.4344 8.92697 13.327C8.75316 13.4957 8.5795 13.6643 8.40737 13.8328C8.17975 14.0557 7.82025 14.0557 7.59263 13.8328C7.4205 13.6643 7.24684 13.4957 7.07303 13.327C6.15344 12.4344 5.22982 11.5378 4.50807 10.6202C3.64488 9.52263 3 8.31099 3 6.92ZM8 5.9C7.3883 5.9 6.93382 6.37952 6.93382 6.92C6.93382 7.46048 7.3883 7.94 8 7.94C8.6117 7.94 9.06618 7.46048 9.06618 6.92C9.06618 6.37952 8.6117 5.9 8 5.9ZM5.75735 6.92C5.75735 5.67108 6.78428 4.7 8 4.7C9.21572 4.7 10.2426 5.67108 10.2426 6.92C10.2426 8.16892 9.21572 9.14 8 9.14C6.78428 9.14 5.75735 8.16892 5.75735 6.92Z" fill={`${color}`} />
    </svg>
  );
};

LocationMarkerSVG.defaultProps = {
  color: getComputedCSSVariable('label-gray'),
};

export default LocationMarkerSVG;
